import { getQueryStringParameter } from '../../../helpers';
import { giveRiskAppreciationWarnings } from '../non_professional_risk_comprehension_step';

$(() => {
  const $form = $('form#legal-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'non_professional_risk_comprehension') {
    return;
  }

  giveRiskAppreciationWarnings($form);
});
